import useInterval from '../../../utils/Interval/useInterval'
import { useAppDispatch, useAppSelector } from '../../utils/hooks'
import {
	actionFetchCampaignDetails,
	actionResetCampaignDetails,
	selectDetailsData,
	selectDetailsStatus,
} from '../../slices/campaign/campaignSlice'
import { Status } from '../../types'
import { useEffect } from 'react'

export default function useActionFetchCampaign(campaignId: string, stop: boolean = false, interval?: number) {
	const dispatch = useAppDispatch()
	const campaignDetails = useAppSelector(selectDetailsData)
	const detailsStatus = useAppSelector(selectDetailsStatus)

	useInterval(() => {
		if (stop) return
		dispatch(actionFetchCampaignDetails(campaignId))
	}, interval)

	useEffect(() => {
		dispatch(actionResetCampaignDetails())
		dispatch(actionFetchCampaignDetails(campaignId))
	}, [campaignId, dispatch])

	return {
		campaignDetails,
		fetching: detailsStatus === Status.PENDING,
	}
}
